import React, { useState } from "react";
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    TextField,
    Button,
    CircularProgress,
} from "@material-ui/core";

import axios from "axios";

const NoShowPopup = ({ open, onClose, reservation }) => {
    const [dayValue, setDayValue] = useState(1);
    const [percentValue, setPercentValue] = useState(20);
    const [loading, setLoading] = useState(false);

    const styleOk = {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "flex-end",
    };

    const handleSave = (type, value = null) => {
        setLoading(true);
        let hash;
        switch (type) {
            case "day":
                hash = reservation.noShow.dayHash;
                break;
            case "percent":
                hash = reservation.noShow.percentHash;
                break;
            case "max":
                hash = reservation.noShow.maxHash;
                break;
        }

        let url = `${reservation.noShow.apiUrl}/index.php?route=extension/payment/yoomoney/noshow&order_id=${reservation.id}&type=${type}&value=${value}&initiator=${reservation.noShow.initiator}&security=${hash}`;

        if (type === "max") {
            url = `${reservation.noShow.apiUrl}/index.php?route=extension/payment/yoomoney/noshow&order_id=${reservation.id}&type=${type}&initiator=${reservation.noShow.initiator}&security=${hash}`;
        }

        axios
            .get(url)
            .then((response) => {
                if (response.data.status === "ok") {
                    alert("Списание успешно произведено");
                } else if (response.data.status === "error") {
                    alert(response.data.result);
                } else {
                    alert(
                        "Попытка списания не удалась. Обратитесь к техническому специалисту.",
                    );
                }
            })
            .catch((error) => {
                console.error(error);
                alert(
                    "Попытка списания не удалась. Обратитесь к техническому специалисту.",
                );
            })
            .finally(() => {
                setLoading(false);
            });
    };

    return (
        <Dialog maxWidth="xl" open={open} onClose={onClose}>
            <DialogTitle>Списание NoShow</DialogTitle>
            {loading ? (
                <div
                    style={{
                        width: "387px",
                        height: "120px",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                    }}
                >
                    <CircularProgress />
                </div>
            ) : (
                <DialogContent>
                    <div style={styleOk}>
                        <span style={{ marginRight: "5px" }}>Списать</span>
                        <TextField
                            type="number"
                            value={dayValue}
                            onChange={(e) => setDayValue(e.target.value)}
                        />
                        сутки
                        <Button
                            onClick={() => handleSave("day", dayValue)}
                            color="primary"
                        >
                            ОК
                        </Button>
                    </div>
                    <div style={styleOk}>
                        <span style={{ marginRight: "5px" }}>Списать</span>
                        <TextField
                            type="number"
                            value={percentValue}
                            onChange={(e) => setPercentValue(e.target.value)}
                        />
                        %
                        <Button
                            onClick={() => handleSave("percent", percentValue)}
                            color="primary"
                        >
                            ОК
                        </Button>
                    </div>
                    <div style={styleOk}>
                        <span>Списать максимум</span>
                        <Button
                            onClick={() => handleSave("max")}
                            color="primary"
                        >
                            ОК
                        </Button>
                    </div>
                </DialogContent>
            )}
            <DialogActions>
                <Button onClick={onClose} color="primary">
                    Отмена
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default NoShowPopup;
